"use client";

import Flag from '@/app/components/flag';
import Title from '@/app/components/title';
import React from 'react';
import Link from 'next/link';
import { usePathname } from "next/navigation";
import {getStrapiURL} from "../../../helper/image-helper";

interface FlagsProps {
    data: {
        title: string;
        country: Array<{
            name: string;
            link: string;
            image: {
                url: string;
            };
        }>;
    };
}


const Flags: React.FC<FlagsProps> = ({ data }) => {

    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");
    
    const getFullPath = (url: string) => `${isEn ? '/en' : ''}/${url}`;

    return (
        <section className="bg-[#f5f6fe] pt-12 pb-[128px] mt-[116px]">
            <div className="container">
                <Title text={data.title} position='left' fontSize='text-[38px]'/>
                <div className="flex gap-[70px] gap-y-[56px] max-[576px]:gap-[24px] max-[576px]:gap-y-[16px] flex-wrap pt-14 justify-between max-[576px]:pt-[28px]">
                    {data.country.map((item, index) => {
                        const fullPath = getFullPath(item.link);
                        return (
                            <Link key={index} href={fullPath}>
                                <Flag icon={getStrapiURL(item.image?.url)} name={item.name} />
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    )
}

export default Flags